// extracted by mini-css-extract-plugin
export default {"addresses":"Addreses_addresses__KCBuX","address":"Addreses_address__AfNd5","title":"Addreses_title__GSn0o","value":"Addreses_value__joWB0","missing":"Addreses_missing__7+jQJ"};